export const emilId = "info@e2eresearch.com";

export const phoneNo = ["+91-1120897708"];

export const message = ["How Can I Help You?", "REQUEST A QUOTE"];

export const copyText = " Copyright © 2024 E2E Research Services Pvt. Ltd.";
